/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateFullKreditNotaRequestDto as OkEgisServiceModelsDtoCreateFullKreditNotaRequestDto } from '../models/OK/Egis/Service/Models/DTO/create-full-kredit-nota-request-dto';
import { CreateFullKreditNotaResponseDto as OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto } from '../models/OK/Egis/Service/Models/DTO/create-full-kredit-nota-response-dto';
import { CreateKreditNotaForServiceintervalRequestDto as OkEgisServiceModelsDtoCreateKreditNotaForServiceintervalRequestDto } from '../models/OK/Egis/Service/Models/DTO/create-kredit-nota-for-serviceinterval-request-dto';

@Injectable({
  providedIn: 'root',
})
export class KreditnotaService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createFullKreditnota
   */
  static readonly CreateFullKreditnotaPath = '/api/v1/Kreditnota/CreateFullKreditnota';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFullKreditnota()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFullKreditnota$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoCreateFullKreditNotaRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, KreditnotaService.CreateFullKreditnotaPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createFullKreditnota$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFullKreditnota(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoCreateFullKreditNotaRequestDto
  }): Observable<OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto> {

    return this.createFullKreditnota$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto>) => r.body as OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto)
    );
  }

  /**
   * Path part for operation createKreditnotaForServiceinterval
   */
  static readonly CreateKreditnotaForServiceintervalPath = '/api/v1/Kreditnota/CreateKreditnotaForServiceinterval';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createKreditnotaForServiceinterval()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createKreditnotaForServiceinterval$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoCreateKreditNotaForServiceintervalRequestDto
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, KreditnotaService.CreateKreditnotaForServiceintervalPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createKreditnotaForServiceinterval$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createKreditnotaForServiceinterval(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsDtoCreateKreditNotaForServiceintervalRequestDto
  }): Observable<OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto> {

    return this.createKreditnotaForServiceinterval$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto>) => r.body as OkEgisServiceModelsDtoCreateFullKreditNotaResponseDto)
    );
  }

}
